import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';

const useStyles = makeStyles({
  webkitBox: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    boxOrient: 'vertical',
    lineClamp: 2,
    wordBreak: 'break-all'
  },
  webkitBoxOneLine: {
    lineClamp: 1
  },
  snippet: {
    fontStyle: 'italic'
  }
});

interface CriteriumSnippetElementProps {
  snippet: string
  nodeLabel: string
}

export const CriteriumSnippetElement = ({ snippet, nodeLabel }: CriteriumSnippetElementProps) => {
  const classes = useStyles();
  return (
    <>
      <div className={classnames(classes.webkitBox, classes.webkitBoxOneLine)}>{nodeLabel}</div>
      <div className={classnames(classes.webkitBox, classes.snippet)}>{snippet}</div>
    </>
  );
};

export default CriteriumSnippetElement;
